import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import db from "../../table.json";

import tabela from "../../assets/tabelaTeste.png";

import "./styles.css";

const TableBootstrap = () => {
  return (
    <div className="wrapper">
      <div
        style={{
          width: "100%",
          marginTop: 20,
          marginRight: 10,
          marginLeft: 10,
        }}
      >
        <BootstrapTable data={db} striped hover>
          <TableHeaderColumn isKey dataField="id">
            Product ID
          </TableHeaderColumn>
          <TableHeaderColumn dataField="name">Product Name</TableHeaderColumn>
          <TableHeaderColumn dataField="type">Type</TableHeaderColumn>
          <TableHeaderColumn dataField="language">Language</TableHeaderColumn>
        </BootstrapTable>
      </div>
      <div>
        <img style={{ width: "100%", margin: 20 }} src={tabela} />
      </div>
    </div>
  );
};

export default TableBootstrap;
